import { render } from "./ModalSoalPreview.vue?vue&type=template&id=20dbeecf&scoped=true"
import script from "./ModalSoalPreview.vue?vue&type=script&lang=js"
export * from "./ModalSoalPreview.vue?vue&type=script&lang=js"

import "./ModalSoalPreview.vue?vue&type=style&index=0&id=20dbeecf&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/WwEazHb5/0/pln-pusdiklat/ups/assessment_hc_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20dbeecf"]])

export default __exports__